import { LINKS } from "../lib/constants";

export default function StoreButtons({ testIdPrefix = "cta" }) {
    return (
        <div
            className="flex flex-wrap items-center gap-3"
            data-testid={`${testIdPrefix}-store-buttons`}
        >
            <a
                href={LINKS.appStore}
                target="_blank"
                rel="noreferrer"
                data-testid={`${testIdPrefix}-appstore-btn`}
                className="group inline-flex items-center gap-3 bg-white text-black rounded-2xl px-5 py-3 min-w-[180px] hover:bg-white/90 transition-all"
            >
                <svg
                    viewBox="0 0 24 24"
                    className="w-7 h-7"
                    fill="currentColor"
                    aria-hidden
                >
                    <path d="M16.365 1.43c0 1.14-.44 2.22-1.17 3-.78.85-2.04 1.5-3.1 1.41-.12-1.06.4-2.16 1.12-2.87.79-.8 2.13-1.41 3.15-1.54zM20.5 17.04c-.51 1.17-.76 1.69-1.41 2.72-.91 1.44-2.2 3.24-3.8 3.25-1.42.02-1.79-.93-3.72-.92-1.93.01-2.34.93-3.76.92-1.6-.01-2.82-1.63-3.74-3.07C1.56 16.8 1.3 11.87 2.88 9.27c1.13-1.87 2.91-2.96 4.58-2.96 1.71 0 2.79.94 4.2.94 1.38 0 2.22-.94 4.2-.94 1.49 0 3.07.81 4.2 2.22-3.69 2.02-3.09 7.29.44 8.51z" />
                </svg>
                <div className="text-left leading-tight">
                    <div className="text-[10px] uppercase tracking-wider opacity-70">
                        Download on the
                    </div>
                    <div className="font-display font-bold text-lg">
                        App Store
                    </div>
                </div>
            </a>
            <a
                href={LINKS.googlePlay}
                target="_blank"
                rel="noreferrer"
                data-testid={`${testIdPrefix}-googleplay-btn`}
                className="group inline-flex items-center gap-3 bg-white text-black rounded-2xl px-5 py-3 min-w-[180px] hover:bg-white/90 transition-all"
            >
                <svg
                    viewBox="0 0 24 24"
                    className="w-7 h-7"
                    aria-hidden
                >
                    <path
                        fill="#34a853"
                        d="M3.609 1.814 13.792 12 3.61 22.186a1.5 1.5 0 0 1-.609-1.2V3.014a1.5 1.5 0 0 1 .608-1.2z"
                    />
                    <path
                        fill="#fbbc04"
                        d="m16.81 15.018-2.953-3.018 2.953-3.018 3.567 2.02c1.24.702 1.24 2.492 0 3.194z"
                    />
                    <path
                        fill="#ea4335"
                        d="M13.792 12 3.61 1.814a1.5 1.5 0 0 1 1.7-.22L16.81 8.982z"
                    />
                    <path
                        fill="#4285f4"
                        d="M13.792 12 16.81 15.018 5.31 22.406a1.5 1.5 0 0 1-1.7-.22z"
                    />
                </svg>
                <div className="text-left leading-tight">
                    <div className="text-[10px] uppercase tracking-wider opacity-70">
                        Get it on
                    </div>
                    <div className="font-display font-bold text-lg">
                        Google Play
                    </div>
                </div>
            </a>
        </div>
    );
}
